var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "profile-field" },
    [
      _c(_vm.fieldComponent, {
        tag: "component",
        attrs: {
          value: _vm.value,
          field: _vm.field,
          error: _vm.error,
          preview: _vm.preview,
          editable: _vm.editable,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("update", $event)
          },
          change: function ($event) {
            return _vm.$emit("change")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }